import styled from "styled-components";

import { Button } from "@similarweb/ui-components";

export const CloseIconButton = styled(Button)`
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 16px;
    right: 16px;
    min-width: 0;
    width: 37px !important;
    height: 37px;
    padding: 0;
    margin: 0;
`;
